import React, { Component } from "react";
import moment from "moment";
import CalendarImage from "../../comum/components/CalendarImage";
import "rmc-picker/assets/index.css";
import "react-dates/initialize";
import { Label } from "reactstrap";
import { DateRangePicker, ICON_AFTER_POSITION } from "react-dates";

moment.locale("pt-BR");

export default class CalendarioPicker extends Component {
  constructor(props) {
    super(props);
    {
      /* TODO: Refatorar state! (criar controller calendario store) */
    }
    this.dateFormat = this.props.dateFormat ?  this.props.dateFormat : "YYYY-MM-DD"
    this.state = {
      startDate: props.dataInicial
        ? moment(props.dataInicial, this.dateFormat)
        : null,
      endDate: props.dataFinal ? moment(props.dataFinal, this.dateFormat) : null,
      focusedInput: null
    };

    this.changeDate = this.changeDate.bind(this);

    this.msgLimite = false;
  }

  resetDate() {
    this.setState({
      date: moment()
    });
  }

  changeDate(w) {
    if (this.props.maxDiasPermitido && w.startDate && w.endDate) {
      if (w.endDate.diff(w.startDate, 'days') > this.props.maxDiasPermitido) {
        w.startDate = null;
        w.endDate = null;
        this.msgLimite = `Limite para preenchimento é ${this.props.maxDiasPermitido} dias`;
      } else {
        this.msgLimite = false;
      }
    }

    if (!w.startDate) {
      this.props.onChangeInicio(null);
    }
    if (!w.endDate) {
      this.props.onChangeFim(null);
    }

    this.setState({
      startDate: w.startDate,
      endDate: w.endDate
    });
    w.startDate && this.props.onChangeInicio(w.startDate.format(this.dateFormat));
    w.endDate && this.props.onChangeFim(w.endDate.format(this.dateFormat));

    if (this.props.filtrar) this.props.filtrar();
  }

  render() {
    const { startDate, endDate, focusedInput } = this.state;

    const msgAlerta = (this.msgLimite) ? this.msgLimite : this.props.alerta;

    return (
      <React.Fragment>
        <DateRangePicker
          startDate={startDate}
          startDateId="your_unique_start_date_id"
          endDate={endDate}
          endDateId="your_unique_end_date_id"
          startDatePlaceholderText="Data inicial"
          endDatePlaceholderText="Data final"
          onDatesChange={this.changeDate}
          focusedInput={focusedInput}
          onFocusChange={focusedInput => this.setState({ focusedInput })}
          hideKeyboardShortcutsPanel={true}
          isOutsideRange={() => false}
          numberOfMonths={1}
          openDirection={
            this.props.openDirection ? this.props.openDirection : "down"
          }
          displayFormat={"DD MMM, YYYY"}
          customArrowIcon="-"
          customInputIcon={!this.props.close ? <CalendarImage /> : null}
          showClearDates={this.props.close}
          inputIconPosition={ICON_AFTER_POSITION}
          disabled={this.props.bloqueado}
        />
        { msgAlerta
          && <Label className="label-danger">{ msgAlerta }</Label>
        }
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/Calendario.js